// Cart Drawer Functions - Updated for new cart drawer structure
function openCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');

  if (drawer && overlay) {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('cart-open');
  }

  // Also call global function if available
  if (window.openCartDrawer) {
    window.openCartDrawer();
  }
}

function closeCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');

  if (drawer && overlay) {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('cart-open');
  }
}

function updateCartItemCounts(count) {
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });

  // Update drawer header badge (just the number)
  document.querySelectorAll('.cart-item-count').forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  try {
    const res = await fetch('/?section_id=cart-drawer');
    const text = await res.text();
    const html = document.createElement('div');
    html.innerHTML = text;

    // Update content
    const newContent = html.querySelector('[data-cart-content]');
    const currentContent = document.querySelector('[data-cart-content]');
    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
    }

    // Update footer
    const newFooter = html.querySelector('.cart-drawer-footer');
    const currentFooter = document.querySelector('.cart-drawer-footer');
    const drawer = document.querySelector('[data-cart-drawer]');

    if (newFooter && currentFooter) {
      currentFooter.outerHTML = newFooter.outerHTML;
    } else if (newFooter && !currentFooter && drawer) {
      drawer.appendChild(newFooter.cloneNode(true));
    } else if (!newFooter && currentFooter) {
      currentFooter.remove();
    }

    // Re-attach event listeners
    addCartDrawerListeners();
  } catch (error) {
    console.error('Cart update error:', error);
  }
}

function addCartDrawerListeners() {
  // Quantity minus buttons
  document.querySelectorAll('[data-qty-minus]').forEach((btn) => {
    btn.addEventListener('click', async function() {
      const item = this.closest('[data-cart-item]');
      if (!item) return;

      const line = parseInt(item.dataset.line);
      const qtyEl = item.querySelector('[data-qty-value]');
      const qty = parseInt(qtyEl.textContent);

      item.classList.add('is-loading');

      const newQty = qty > 1 ? qty - 1 : 0;
      await updateCartLine(line, newQty);
    });
  });

  // Quantity plus buttons
  document.querySelectorAll('[data-qty-plus]').forEach((btn) => {
    btn.addEventListener('click', async function() {
      const item = this.closest('[data-cart-item]');
      if (!item) return;

      const line = parseInt(item.dataset.line);
      const qtyEl = item.querySelector('[data-qty-value]');
      const qty = parseInt(qtyEl.textContent);

      item.classList.add('is-loading');

      await updateCartLine(line, qty + 1);
    });
  });

  // Remove item buttons
  document.querySelectorAll('[data-remove-item]').forEach((btn) => {
    btn.addEventListener('click', async function() {
      const item = this.closest('[data-cart-item]');
      if (!item) return;

      const line = parseInt(item.dataset.line);
      item.classList.add('is-loading');

      await updateCartLine(line, 0);
    });
  });

  // Close buttons
  document.querySelectorAll('[data-cart-close]').forEach((el) => {
    el.addEventListener('click', closeCartDrawer);
  });

  // Overlay click
  const overlay = document.querySelector('[data-cart-overlay]');
  if (overlay) {
    overlay.addEventListener('click', closeCartDrawer);
  }
}

async function updateCartLine(line, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ line, quantity }),
    });

    const cart = await res.json();
    updateCartItemCounts(cart.item_count);
    await updateCartDrawer();
  } catch (error) {
    console.error('Cart line update error:', error);
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  addCartDrawerListeners();

  // Cart toggle buttons
  document.querySelectorAll('[data-cart-drawer-toggle]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // Cart links (a[href="/cart"])
  document.querySelectorAll('a[href="/cart"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // ESC key to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCartDrawer();
    }
  });
});

// Add to cart form handling
document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    try {
      // Submit form with ajax
      await fetch('/cart/add', {
        method: 'POST',
        body: new FormData(form),
      });

      // Get cart count
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);

      // Update cart drawer
      await updateCartDrawer();

      // Open cart drawer
      openCartDrawer();
    } catch (error) {
      console.error('Add to cart error:', error);
    }
  });
});

// Countdown timer (if elements exist)
function updateCountdown() {
  const dayEl = document.getElementById('day');
  const hourEl = document.getElementById('hour');
  const minuteEl = document.getElementById('minute');
  const secondEl = document.getElementById('second');

  if (!dayEl || !hourEl || !minuteEl || !secondEl) return;

  const now = new Date();
  const deadline = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 4
  );
  const totalSeconds = (deadline - now) / 1000;

  const days = Math.floor(totalSeconds / 3600 / 24);
  const hours = Math.floor(totalSeconds / 3600) % 24;
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const seconds = Math.floor(totalSeconds) % 60;

  dayEl.textContent = days;
  hourEl.textContent = String(hours).padStart(2, '0');
  minuteEl.textContent = String(minutes).padStart(2, '0');
  secondEl.textContent = String(seconds).padStart(2, '0');
}

setInterval(updateCountdown, 1000);
